export function obtieneCargadoresEstados() {
  const terminalId = parseInt(localStorage.getItem("terminalId"));

  switch (terminalId) {
    case 1:
      return [
        { nombre: "A1-L", cargando: false, errorCarga: false },
        { nombre: "A1-R", cargando: false, errorCarga: false },
        { nombre: "A2-L", cargando: false, errorCarga: false },
        { nombre: "A2-R", cargando: false, errorCarga: false },
        { nombre: "A3-L", cargando: false, errorCarga: false },
        { nombre: "A3-R", cargando: false, errorCarga: false },
        { nombre: "A4-L", cargando: false, errorCarga: false },
        { nombre: "A4-R", cargando: false, errorCarga: false },
        { nombre: "A5-L", cargando: false, errorCarga: false },
        { nombre: "A5-R", cargando: false, errorCarga: false },
        { nombre: "A6-L", cargando: false, errorCarga: false },
        { nombre: "A6-R", cargando: false, errorCarga: false },
        { nombre: "A7-L", cargando: false, errorCarga: false },
        { nombre: "A7-R", cargando: false, errorCarga: false },
        { nombre: "B1-L", cargando: false, errorCarga: false },
        { nombre: "B1-R", cargando: false, errorCarga: false },
        { nombre: "B2-L", cargando: false, errorCarga: false },
        { nombre: "B2-R", cargando: false, errorCarga: false },
        { nombre: "B3-L", cargando: false, errorCarga: false },
        { nombre: "B3-R", cargando: false, errorCarga: false },
        { nombre: "B4-L", cargando: false, errorCarga: false },
        { nombre: "B4-R", cargando: false, errorCarga: false },
        { nombre: "B5-L", cargando: false, errorCarga: false },
        { nombre: "B5-R", cargando: false, errorCarga: false },
        { nombre: "B6-L", cargando: false, errorCarga: false },
        { nombre: "B6-R", cargando: false, errorCarga: false },
        { nombre: "B7-L", cargando: false, errorCarga: false },
        { nombre: "B7-R", cargando: false, errorCarga: false },
        { nombre: "C1-L", cargando: false, errorCarga: false },
        { nombre: "C1-R", cargando: false, errorCarga: false },
        { nombre: "C2-L", cargando: false, errorCarga: false },
        { nombre: "C2-R", cargando: false, errorCarga: false },
        { nombre: "C3-L", cargando: false, errorCarga: false },
        { nombre: "C3-R", cargando: false, errorCarga: false },
        { nombre: "C4-L", cargando: false, errorCarga: false },
        { nombre: "C4-R", cargando: false, errorCarga: false },
        { nombre: "C5-L", cargando: false, errorCarga: false },
        { nombre: "C5-R", cargando: false, errorCarga: false },
        { nombre: "C6-L", cargando: false, errorCarga: false },
        { nombre: "C6-R", cargando: false, errorCarga: false },
        { nombre: "C7-L", cargando: false, errorCarga: false },
        { nombre: "C7-R", cargando: false, errorCarga: false },
        { nombre: "D1-L", cargando: false, errorCarga: false },
        { nombre: "D1-R", cargando: false, errorCarga: false },
        { nombre: "D2-L", cargando: false, errorCarga: false },
        { nombre: "D2-R", cargando: false, errorCarga: false },
        { nombre: "D3-L", cargando: false, errorCarga: false },
        { nombre: "D3-R", cargando: false, errorCarga: false },
        { nombre: "D4-L", cargando: false, errorCarga: false },
        { nombre: "D4-R", cargando: false, errorCarga: false },
        { nombre: "D5-L", cargando: false, errorCarga: false },
        { nombre: "D5-R", cargando: false, errorCarga: false },
        { nombre: "D6-L", cargando: false, errorCarga: false },
        { nombre: "D6-R", cargando: false, errorCarga: false },
        { nombre: "D7-L", cargando: false, errorCarga: false },
        { nombre: "D7-R", cargando: false, errorCarga: false },
        { nombre: "E1-L", cargando: false, errorCarga: false },
        { nombre: "E1-R", cargando: false, errorCarga: false },
        { nombre: "E2-L", cargando: false, errorCarga: false },
        { nombre: "E2-R", cargando: false, errorCarga: false },
        { nombre: "E3-L", cargando: false, errorCarga: false },
        { nombre: "E3-R", cargando: false, errorCarga: false },
        { nombre: "E4-L", cargando: false, errorCarga: false },
        { nombre: "E4-R", cargando: false, errorCarga: false },
        { nombre: "E5-L", cargando: false, errorCarga: false },
        { nombre: "E5-R", cargando: false, errorCarga: false },
        { nombre: "E6-L", cargando: false, errorCarga: false },
        { nombre: "E6-R", cargando: false, errorCarga: false },
        { nombre: "E7-L", cargando: false, errorCarga: false },
        { nombre: "E7-R", cargando: false, errorCarga: false },
        { nombre: "F1-L", cargando: false, errorCarga: false },
        { nombre: "F1-R", cargando: false, errorCarga: false },
        { nombre: "F2-L", cargando: false, errorCarga: false },
        { nombre: "F2-R", cargando: false, errorCarga: false },
        { nombre: "F3-L", cargando: false, errorCarga: false },
        { nombre: "F3-R", cargando: false, errorCarga: false },
        { nombre: "F4-L", cargando: false, errorCarga: false },
        { nombre: "F4-R", cargando: false, errorCarga: false },
        { nombre: "F5-L", cargando: false, errorCarga: false },
        { nombre: "F5-R", cargando: false, errorCarga: false },
        { nombre: "F6-L", cargando: false, errorCarga: false },
        { nombre: "F6-R", cargando: false, errorCarga: false },
        { nombre: "F7-L", cargando: false, errorCarga: false },
        { nombre: "F7-R", cargando: false, errorCarga: false },
        { nombre: "G1-L", cargando: false, errorCarga: false },
        { nombre: "G1-R", cargando: false, errorCarga: false },
        { nombre: "G2-L", cargando: false, errorCarga: false },
        { nombre: "G2-R", cargando: false, errorCarga: false },
        { nombre: "G3-L", cargando: false, errorCarga: false },
        { nombre: "G3-R", cargando: false, errorCarga: false },
        { nombre: "G4-L", cargando: false, errorCarga: false },
        { nombre: "G4-R", cargando: false, errorCarga: false },
        { nombre: "G5-L", cargando: false, errorCarga: false },
        { nombre: "G5-R", cargando: false, errorCarga: false },
        { nombre: "G6-L", cargando: false, errorCarga: false },
        { nombre: "G6-R", cargando: false, errorCarga: false },
        { nombre: "G7-L", cargando: false, errorCarga: false },
        { nombre: "G7-R", cargando: false, errorCarga: false },
        { nombre: "H1-L", cargando: false, errorCarga: false },
        { nombre: "H1-R", cargando: false, errorCarga: false },
        { nombre: "H2-L", cargando: false, errorCarga: false },
        { nombre: "H2-R", cargando: false, errorCarga: false },
        { nombre: "H3-L", cargando: false, errorCarga: false },
        { nombre: "H3-R", cargando: false, errorCarga: false },
        { nombre: "H4-L", cargando: false, errorCarga: false },
        { nombre: "H4-R", cargando: false, errorCarga: false },
        { nombre: "H5-L", cargando: false, errorCarga: false },
        { nombre: "H5-R", cargando: false, errorCarga: false },
        { nombre: "H6-L", cargando: false, errorCarga: false },
        { nombre: "H6-R", cargando: false, errorCarga: false },
        { nombre: "H7-L", cargando: false, errorCarga: false },
        { nombre: "H7-R", cargando: false, errorCarga: false },
        { nombre: "I1-L", cargando: false, errorCarga: false },
        { nombre: "I1-R", cargando: false, errorCarga: false },
        { nombre: "I2-L", cargando: false, errorCarga: false },
        { nombre: "I2-R", cargando: false, errorCarga: false },
        { nombre: "I3-L", cargando: false, errorCarga: false },
        { nombre: "I3-R", cargando: false, errorCarga: false },
        { nombre: "I4-L", cargando: false, errorCarga: false },
        { nombre: "I4-R", cargando: false, errorCarga: false },
        { nombre: "I5-L", cargando: false, errorCarga: false },
        { nombre: "I5-R", cargando: false, errorCarga: false },
        { nombre: "I6-L", cargando: false, errorCarga: false },
        { nombre: "I6-R", cargando: false, errorCarga: false },
        { nombre: "I7-L", cargando: false, errorCarga: false },
        { nombre: "I7-R", cargando: false, errorCarga: false },
      ];
    case 2:
      return [
        { nombre: "A1-R", cargando: false, errorCarga: false },
        { nombre: "A1-L", cargando: false, errorCarga: false },
        { nombre: "A2-R", cargando: false, errorCarga: false },
        { nombre: "A2-L", cargando: false, errorCarga: false },
        { nombre: "A3-R", cargando: false, errorCarga: false },
        { nombre: "A3-L", cargando: false, errorCarga: false },
        { nombre: "A4-R", cargando: false, errorCarga: false },
        { nombre: "A4-L", cargando: false, errorCarga: false },
        { nombre: "B5-R", cargando: false, errorCarga: false },
        { nombre: "B5-L", cargando: false, errorCarga: false },
        { nombre: "B6-R", cargando: false, errorCarga: false },
        { nombre: "B6-L", cargando: false, errorCarga: false },
        { nombre: "B7-R", cargando: false, errorCarga: false },
        { nombre: "B7-L", cargando: false, errorCarga: false },
        { nombre: "B8-R", cargando: false, errorCarga: false },
        { nombre: "B8-L", cargando: false, errorCarga: false },
        { nombre: "B9-R", cargando: false, errorCarga: false },
        { nombre: "B9-L", cargando: false, errorCarga: false },
        { nombre: "C10-R", cargando: false, errorCarga: false },
        { nombre: "C10-L", cargando: false, errorCarga: false },
        { nombre: "C11-R", cargando: false, errorCarga: false },
        { nombre: "C11-L", cargando: false, errorCarga: false },
        { nombre: "C12-R", cargando: false, errorCarga: false },
        { nombre: "C12-L", cargando: false, errorCarga: false },
        { nombre: "C13-R", cargando: false, errorCarga: false },
        { nombre: "C13-L", cargando: false, errorCarga: false },
        { nombre: "D14-R", cargando: false, errorCarga: false },
        { nombre: "D14-L", cargando: false, errorCarga: false },
        { nombre: "D15-R", cargando: false, errorCarga: false },
        { nombre: "D15-L", cargando: false, errorCarga: false },
      ];
    case 3:
      return [
        { nombre: "1-A", cargando: false, errorCarga: false },
        { nombre: "1-B", cargando: false, errorCarga: false },
        { nombre: "2-A", cargando: false, errorCarga: false },
        { nombre: "2-B", cargando: false, errorCarga: false },
        { nombre: "3-A", cargando: false, errorCarga: false },
        { nombre: "3-B", cargando: false, errorCarga: false },
        { nombre: "4-A", cargando: false, errorCarga: false },
        { nombre: "4-B", cargando: false, errorCarga: false },
        { nombre: "5-A", cargando: false, errorCarga: false },
        { nombre: "5-B", cargando: false, errorCarga: false },
        { nombre: "6-A", cargando: false, errorCarga: false },
        { nombre: "6-B", cargando: false, errorCarga: false },
        { nombre: "7-A", cargando: false, errorCarga: false },
        { nombre: "7-B", cargando: false, errorCarga: false },
      ];
    case 4:
      return [
        { nombre: "A1-L", cargando: false, errorCarga: false },
        { nombre: "A1-R", cargando: false, errorCarga: false },
        { nombre: "A2-L", cargando: false, errorCarga: false },
        { nombre: "A2-R", cargando: false, errorCarga: false },
        { nombre: "A3-L", cargando: false, errorCarga: false },
        { nombre: "A3-R", cargando: false, errorCarga: false },
        { nombre: "A4-L", cargando: false, errorCarga: false },
        { nombre: "A4-R", cargando: false, errorCarga: false },
        { nombre: "A5-L", cargando: false, errorCarga: false },
        { nombre: "A5-R", cargando: false, errorCarga: false },
        { nombre: "B6-L", cargando: false, errorCarga: false },
        { nombre: "B6-R", cargando: false, errorCarga: false },
        { nombre: "B7-L", cargando: false, errorCarga: false },
        { nombre: "B7-R", cargando: false, errorCarga: false },
        { nombre: "B8-L", cargando: false, errorCarga: false },
        { nombre: "B8-R", cargando: false, errorCarga: false },
        { nombre: "B9-L", cargando: false, errorCarga: false },
        { nombre: "B9-R", cargando: false, errorCarga: false },
        { nombre: "B10-L", cargando: false, errorCarga: false },
        { nombre: "B10-R", cargando: false, errorCarga: false },
        { nombre: "C11-L", cargando: false, errorCarga: false },
        { nombre: "C11-R", cargando: false, errorCarga: false },
        { nombre: "C12-L", cargando: false, errorCarga: false },
        { nombre: "C12-R", cargando: false, errorCarga: false },
        { nombre: "C13-L", cargando: false, errorCarga: false },
        { nombre: "C13-R", cargando: false, errorCarga: false },
        { nombre: "C14-L", cargando: false, errorCarga: false },
        { nombre: "C14-R", cargando: false, errorCarga: false },
      ];
    case 5:
      //la primavera
      return [
        { nombre: "A1-R", cargando: false, errorCarga: false },
        { nombre: "A1-L", cargando: false, errorCarga: false },
        { nombre: "A2-R", cargando: false, errorCarga: false },
        { nombre: "A2-L", cargando: false, errorCarga: false },
        { nombre: "B3-R", cargando: false, errorCarga: false },
        { nombre: "B3-L", cargando: false, errorCarga: false },
        { nombre: "B4-R", cargando: false, errorCarga: false },
        { nombre: "B4-L", cargando: false, errorCarga: false },
        { nombre: "B5-R", cargando: false, errorCarga: false },
        { nombre: "B5-L", cargando: false, errorCarga: false },
        { nombre: "B6-R", cargando: false, errorCarga: false },
        { nombre: "B6-L", cargando: false, errorCarga: false },
        { nombre: "B7-R", cargando: false, errorCarga: false },
        { nombre: "B7-L", cargando: false, errorCarga: false },
        { nombre: "B8-R", cargando: false, errorCarga: false },
        { nombre: "B8-L", cargando: false, errorCarga: false },
        { nombre: "B9-R", cargando: false, errorCarga: false },
        { nombre: "B9-L", cargando: false, errorCarga: false },
        { nombre: "C10-R", cargando: false, errorCarga: false },
        { nombre: "C10-L", cargando: false, errorCarga: false },
        { nombre: "C11-R", cargando: false, errorCarga: false },
        { nombre: "C11-L", cargando: false, errorCarga: false },
        { nombre: "C12-R", cargando: false, errorCarga: false },
        { nombre: "C12-L", cargando: false, errorCarga: false },
        { nombre: "C13-R", cargando: false, errorCarga: false },
        { nombre: "C13-L", cargando: false, errorCarga: false },
        { nombre: "C14-R", cargando: false, errorCarga: false },
        { nombre: "C14-L", cargando: false, errorCarga: false },
        { nombre: "C15-R", cargando: false, errorCarga: false },
        { nombre: "C15-L", cargando: false, errorCarga: false },
        { nombre: "C16-R", cargando: false, errorCarga: false },
        { nombre: "C16-L", cargando: false, errorCarga: false },
      ];
    case 6:
      return [
        { nombre: "A1-R", cargando: false, errorCarga: false },
        { nombre: "A1-L", cargando: false, errorCarga: false },
        { nombre: "A2-R", cargando: false, errorCarga: false },
        { nombre: "A2-L", cargando: false, errorCarga: false },
        { nombre: "A3-R", cargando: false, errorCarga: false },
        { nombre: "A3-L", cargando: false, errorCarga: false },
        { nombre: "A4-R", cargando: false, errorCarga: false },
        { nombre: "A4-L", cargando: false, errorCarga: false },
        { nombre: "A5-R", cargando: false, errorCarga: false },
        { nombre: "A5-L", cargando: false, errorCarga: false },
        { nombre: "A6-R", cargando: false, errorCarga: false },
        { nombre: "A6-L", cargando: false, errorCarga: false },
        { nombre: "B7-R", cargando: false, errorCarga: false },
        { nombre: "B7-L", cargando: false, errorCarga: false },
        { nombre: "B8-R", cargando: false, errorCarga: false },
        { nombre: "B8-L", cargando: false, errorCarga: false },
        { nombre: "B9-R", cargando: false, errorCarga: false },
        { nombre: "B9-L", cargando: false, errorCarga: false },
        { nombre: "B10-R", cargando: false, errorCarga: false },
        { nombre: "B10-L", cargando: false, errorCarga: false },
        { nombre: "B11-R", cargando: false, errorCarga: false },
        { nombre: "B11-L", cargando: false, errorCarga: false },
        { nombre: "B12-R", cargando: false, errorCarga: false },
        { nombre: "B12-L", cargando: false, errorCarga: false },
        { nombre: "B13-R", cargando: false, errorCarga: false },
        { nombre: "B13-L", cargando: false, errorCarga: false },
      ];
    case 7:
      return [
        { nombre: "A1-R", cargando: false, errorCarga: false },
        { nombre: "A1-L", cargando: false, errorCarga: false },
        { nombre: "A2-R", cargando: false, errorCarga: false },
        { nombre: "A2-L", cargando: false, errorCarga: false },
        { nombre: "A3-R", cargando: false, errorCarga: false },
        { nombre: "A3-L", cargando: false, errorCarga: false },
        { nombre: "A4-R", cargando: false, errorCarga: false },
        { nombre: "A4-L", cargando: false, errorCarga: false },
        { nombre: "A5-R", cargando: false, errorCarga: false },
        { nombre: "A5-L", cargando: false, errorCarga: false },
        { nombre: "A6-R", cargando: false, errorCarga: false },
        { nombre: "A6-L", cargando: false, errorCarga: false },
        { nombre: "A7-R", cargando: false, errorCarga: false },
        { nombre: "A7-L", cargando: false, errorCarga: false },
        { nombre: "A8-R", cargando: false, errorCarga: false },
        { nombre: "A8-L", cargando: false, errorCarga: false },
        { nombre: "B1-R", cargando: false, errorCarga: false },
        { nombre: "B1-L", cargando: false, errorCarga: false },
        { nombre: "B2-R", cargando: false, errorCarga: false },
        { nombre: "B2-L", cargando: false, errorCarga: false },
        { nombre: "B3-R", cargando: false, errorCarga: false },
        { nombre: "B3-L", cargando: false, errorCarga: false },
        { nombre: "B4-R", cargando: false, errorCarga: false },
        { nombre: "B4-L", cargando: false, errorCarga: false },
        { nombre: "B5-R", cargando: false, errorCarga: false },
        { nombre: "B5-L", cargando: false, errorCarga: false },
        { nombre: "B6-R", cargando: false, errorCarga: false },
        { nombre: "B6-L", cargando: false, errorCarga: false },
        { nombre: "B7-R", cargando: false, errorCarga: false },
        { nombre: "B7-L", cargando: false, errorCarga: false },
        { nombre: "B8-R", cargando: false, errorCarga: false },
        { nombre: "B8-L", cargando: false, errorCarga: false },
        { nombre: "C1-R", cargando: false, errorCarga: false },
        { nombre: "C1-L", cargando: false, errorCarga: false },
        { nombre: "C2-R", cargando: false, errorCarga: false },
        { nombre: "C2-L", cargando: false, errorCarga: false },
        { nombre: "C3-R", cargando: false, errorCarga: false },
        { nombre: "C3-L", cargando: false, errorCarga: false },
        { nombre: "C4-R", cargando: false, errorCarga: false },
        { nombre: "C4-L", cargando: false, errorCarga: false },
        { nombre: "C5-R", cargando: false, errorCarga: false },
        { nombre: "C5-L", cargando: false, errorCarga: false },
        { nombre: "C6-R", cargando: false, errorCarga: false },
        { nombre: "C6-L", cargando: false, errorCarga: false },
        { nombre: "C7-R", cargando: false, errorCarga: false },
        { nombre: "C7-L", cargando: false, errorCarga: false },
        { nombre: "C6-R", cargando: false, errorCarga: false },
        { nombre: "C6-L", cargando: false, errorCarga: false },
        { nombre: "D1-R", cargando: false, errorCarga: false },
        { nombre: "D1-L", cargando: false, errorCarga: false },
        { nombre: "D2-R", cargando: false, errorCarga: false },
        { nombre: "D2-L", cargando: false, errorCarga: false },
        { nombre: "D3-R", cargando: false, errorCarga: false },
        { nombre: "D3-L", cargando: false, errorCarga: false },
        { nombre: "D4-R", cargando: false, errorCarga: false },
        { nombre: "D4-L", cargando: false, errorCarga: false },
        { nombre: "D5-R", cargando: false, errorCarga: false },
        { nombre: "D5-L", cargando: false, errorCarga: false },
        { nombre: "D6-R", cargando: false, errorCarga: false },
        { nombre: "D6-L", cargando: false, errorCarga: false },
        { nombre: "D7-R", cargando: false, errorCarga: false },
        { nombre: "D7-L", cargando: false, errorCarga: false },
        { nombre: "E1-R", cargando: false, errorCarga: false },
        { nombre: "E1-L", cargando: false, errorCarga: false },
        { nombre: "E2-R", cargando: false, errorCarga: false },
        { nombre: "E2-L", cargando: false, errorCarga: false },
        { nombre: "E3-R", cargando: false, errorCarga: false },
        { nombre: "E3-L", cargando: false, errorCarga: false },
        { nombre: "E4-R", cargando: false, errorCarga: false },
        { nombre: "E4-L", cargando: false, errorCarga: false },
        { nombre: "E5-R", cargando: false, errorCarga: false },
        { nombre: "E5-L", cargando: false, errorCarga: false },
        { nombre: "E6-R", cargando: false, errorCarga: false },
        { nombre: "E6-L", cargando: false, errorCarga: false },
        { nombre: "E7-R", cargando: false, errorCarga: false },
        { nombre: "E7-L", cargando: false, errorCarga: false },
        { nombre: "E8-R", cargando: false, errorCarga: false },
        { nombre: "E8-L", cargando: false, errorCarga: false },
        { nombre: "F1-R", cargando: false, errorCarga: false },
        { nombre: "F1-L", cargando: false, errorCarga: false },
        { nombre: "F2-R", cargando: false, errorCarga: false },
        { nombre: "F2-L", cargando: false, errorCarga: false },
        { nombre: "F3-R", cargando: false, errorCarga: false },
        { nombre: "F3-L", cargando: false, errorCarga: false },
        { nombre: "F4-R", cargando: false, errorCarga: false },
        { nombre: "F4-L", cargando: false, errorCarga: false },
        { nombre: "F5-R", cargando: false, errorCarga: false },
        { nombre: "F5-L", cargando: false, errorCarga: false },
        { nombre: "F6-R", cargando: false, errorCarga: false },
        { nombre: "F6-L", cargando: false, errorCarga: false },
        { nombre: "F7-R", cargando: false, errorCarga: false },
        { nombre: "F7-L", cargando: false, errorCarga: false },
        { nombre: "F8-R", cargando: false, errorCarga: false },
        { nombre: "F8-L", cargando: false, errorCarga: false },
        { nombre: "F9-R", cargando: false, errorCarga: false },
        { nombre: "F9-L", cargando: false, errorCarga: false },
      ];
    default:
      return [];
  }
}

export default {
  obtieneCargadoresEstados,
};
